import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { city, CityManipulationViewModel } from "./cityManipulation-viewModel"

export class CityManipulationView extends View<CityManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-29F6215A-E72A-4ADC-BC7B-6D8E0F90B114"
    }
    loadHtml(): string {
        let element = require('./cityManipulation.html').default;
        let style = require('./cityManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set city(v: ObservableArray<city>) { this._city = v; } public get city(): ObservableArray<city> { return this._city;} private _city: ObservableArray<city>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestCityCreation(){
        this.dataContext.requestCityCreation();
    }
}
